module.exports = __webpack_public_path__ + "static/media/2_pl.228faf35.png";